"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leadStatusDetails = exports.EMPTY_STATUS = exports.LeadStatus = void 0;
var LeadStatus;
(function (LeadStatus) {
    LeadStatus["NEW"] = "New";
    LeadStatus["APPLIED"] = "Applied";
    LeadStatus["PRE_QUALIFIED"] = "Pre-Qualified";
    LeadStatus["PRE_APPROVED"] = "Pre-Approved";
    LeadStatus["ELIGIBILITY"] = "Eligibility Confirmed";
    LeadStatus["OFFERED"] = "Offered";
    LeadStatus["ACCEPTED"] = "Accepted";
    LeadStatus["MOVED"] = "Moved";
    LeadStatus["INCENTIVE_DELIVERED"] = "Incentive Delivered";
    LeadStatus["DECLINED"] = "Declined";
})(LeadStatus = exports.LeadStatus || (exports.LeadStatus = {}));
exports.EMPTY_STATUS = 'None';
exports.leadStatusDetails = [
    { title: 'New', value: LeadStatus.NEW, description: 'Mover saves your community or one of your offers' },
    { title: 'Applied', value: LeadStatus.APPLIED, description: 'Mover applies to an offer' },
    { title: 'Pre-Approved', value: LeadStatus.PRE_APPROVED, description: 'Mover meets minimum qualification requirements' },
    { title: 'Eligibility Confirmed', value: LeadStatus.ELIGIBILITY, description: 'Representative confirms mover\'s eligibility to claim offer' },
    { title: 'Offered', value: LeadStatus.OFFERED, description: 'Representative formally makes the final offer to the mover' },
    { title: 'Accepted', value: LeadStatus.ACCEPTED, description: 'Mover accepts the offer and prepares to move' },
    { title: 'Moved', value: LeadStatus.MOVED, description: 'Mover completes the move to the location' },
    { title: 'Incentive Delivered', value: LeadStatus.INCENTIVE_DELIVERED, description: 'Mover has been given the incentive' },
    { title: 'Declined', value: LeadStatus.DECLINED, description: 'Mover\'s application is declined, or otherwise drops out of the process' },
];
